import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Avatar, FlexBox, Tooltip } from '@dixa/lib-shared-habla';
import { Highlight } from 'components/highlight';
const UserItem = ({ user, closeDropDown, add, highlighted, resetValue, }) => {
    let email = '';
    let name = '';
    let avatar = _jsx(Avatar, { user: user });
    let highlightedClassName = '';
    if (user.icon !== undefined) {
        avatar = _jsx(DixaIcon, { className: "s-icon loading-image", icon: user.icon });
    }
    if (user._highlights &&
        user._highlights.display_name &&
        user._highlights.display_name.length) {
        name = _jsx(Highlight, { highlightedValue: user._highlights.display_name[0] });
    }
    else if (typeof user.name === 'string' ||
        typeof user.display_name === 'string') {
        name = typeof user.name === 'string' ? user.name : user.display_name;
    }
    if (user._highlights &&
        user._highlights.email &&
        user._highlights.email.length) {
        email =
            name !== '' ? (_jsx(Highlight, { highlightedValue: `<${user._highlights.email[0]}>` })) : (_jsx(Highlight, { highlightedValue: user._highlights.email[0] }));
    }
    else if (typeof user.email === 'string') {
        email = name !== '' ? `<${user.email}>` : user.email;
    }
    if (highlighted === true) {
        highlightedClassName = 'highlighted';
    }
    return (_jsx(Tooltip, Object.assign({ content: email, dark: true }, { children: _jsxs("div", Object.assign({ className: `user-item ${highlightedClassName}`, onClick: () => {
                add({ user: user });
                resetValue();
                closeDropDown();
            } }, { children: [avatar, _jsxs(FlexBox, Object.assign({ flexDirection: "column" }, { children: [_jsx("div", Object.assign({ className: "name" }, { children: name })), _jsx("div", Object.assign({ className: "email" }, { children: email }))] }))] })) })));
};
export default UserItem;
